<!--
 * @Descripttion: 一般劳务
 * @Date: 2024-08-06 13:58:47
-->
<template>
  <div class="average-order-list">
    <xrk-table
      ref="xrkTableRef"
      :getListAjax="getListAjax"
      :searchConfig="searchConfig"
      :tableConfig="tableConfig"
    ></xrk-table>
  </div>
</template>

<script lang="tsx" setup>
import { computed, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import {
  XrkTable,
  XrkTableProps,
  useTableColumn,
  BaseButton,
  XrkTableRef,
  XrkMessage
} from 'xrk-components';
import { previewBill } from '@/utils/download';

import {
  continuousLabourExport,
  continuousLabourList
} from '../data-source/apis';
import {
  orderNoCol,
  fullNameCol,
  cardNumberCol,
  phoneCol,
  projectNameCol,
  projectNoCol,
  entpNameCol,
  aspNameCol,
  aspDeductionTimeCol,
  endPointFinishPayAtCol,
  payTypeCol,
  payPassagewayCol,
  csoPriceSumCol,
  cumMoneyCol,
  cumFeeCol,
  monthDeductFeeCol,
  cumDeductFeeCol,
  monthTaxFreeCol,
  cumTaxFreeCol,
  monthOtherDeductCol,
  cumOtherDeductCol,
  prepaidIncomeTaxCol,
  taxRateCol,
  quickDeductCol,
  monthDeductTaxCol,
  cumDeductTaxCol,
  cumPrepaidTaxAmountCol,
  prepaidTaxAmountCol,
  taxAfterAmountCol,
  cumDeductFeeExpectCol
} from '../fields/columns';
import {
  projectOrderNoSearch,
  fullNameSearch,
  phoneSearch,
  projectNameSearch,
  projectNoSearch,
  entpNameSearch,
  aspDeductionTimeSearch,
  terminalAccountTimeSearch
} from '../fields/searchs';
import {
  batchDownLoadReceipt,
  downLoadReceipt
} from '@/common/hooks/order/order-download';

const xrkTableRef = ref<XrkTableRef>();
const router = useRouter();
const route = useRoute();
const selectionVal = computed(() => {
  return xrkTableRef.value?.getSelectionRows();
});
// 搜索项
const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchBtn: {
    show: true,
    text: '搜索'
  },
  resetBtn: {
    show: true,
    text: '重置',
    beforeReset: () => {
      // 清除路由上的查询参数
      if (route.query.orderNo) {
        router.replace({
          query: { force: Date.now() }
        });
      }
    }
  },
  searchColumns: [
    projectOrderNoSearch,
    fullNameSearch,
    phoneSearch,
    projectNameSearch,
    projectNoSearch,
    entpNameSearch,
    aspDeductionTimeSearch,
    terminalAccountTimeSearch
  ],
  otherComponents: [
    {
      render() {
        return (
          <>
            <BaseButton
              v-resource={[['连续劳务_导出']]}
              type="primary2"
              click={async () => {
                await continuousLabourExport({
                  ...xrkTableRef.value.getSearchValue(),
                  idList: selectionVal.value.map(item => item.id)
                });
              }}
            >
              导出
            </BaseButton>
            <BaseButton
              v-resource={[['连续劳务_下载回单']]}
              type="primary2"
              onClick={async () => {
                if (selectionVal.value.length === 0) {
                  XrkMessage.error('请至少选择一条下载');
                  return;
                }
                //批量下载回单
                await batchDownLoadReceipt({
                  downloadType: 502,
                  downloadList: selectionVal.value.map(item => {
                    return {
                      id: item.id
                    };
                  })
                });
              }}
            >
              批量下载回单
            </BaseButton>
          </>
        );
      }
    }
  ]
});

// 列表
const tableConfig = ref<XrkTableProps['tableConfig']>({
  tableColumns: [
    useTableColumn({
      type: '_selection',
      prop: 'id',
      align: 'center',
      fixed: 'left',
      width: 120
    }),
    useTableColumn({
      type: 'index',
      label: '序号'
    }),
    orderNoCol,
    fullNameCol,
    cardNumberCol,
    phoneCol,
    projectNameCol,
    projectNoCol,
    entpNameCol,
    aspNameCol,
    aspDeductionTimeCol,
    endPointFinishPayAtCol,
    payTypeCol,
    payPassagewayCol,
    csoPriceSumCol,
    cumMoneyCol,
    cumFeeCol,
    monthDeductFeeCol,
    cumDeductFeeCol,
    cumDeductFeeExpectCol,
    monthTaxFreeCol,
    cumTaxFreeCol,
    monthOtherDeductCol,
    cumOtherDeductCol,
    prepaidIncomeTaxCol,
    taxRateCol,
    quickDeductCol,
    monthDeductTaxCol,
    cumDeductTaxCol,
    cumPrepaidTaxAmountCol,
    prepaidTaxAmountCol,
    taxAfterAmountCol,
    useTableColumn({
      align: 'center',
      fixed: 'right',
      label: '支付回单',
      width: 230,
      render({ row }) {
        return (
          <>
            <div>
              <BaseButton
                disabled={!row.receiptUrl || row.receiptUrl === '-'}
                onClick={async () => {
                  // 查看回单
                  previewBill(row.receiptUrl);
                }}
                type="text"
              >
                查看
              </BaseButton>

              <BaseButton
                v-resource={[['连续劳务_下载回单']]}
                disabled={!row.receiptUrl || row.receiptUrl === '-'}
                onClick={async () => {
                  // 下载回单
                  downLoadReceipt(row.receiptUrl);
                }}
                type="text"
              >
                下载
              </BaseButton>
            </div>
          </>
        );
      }
    })
  ],
  baseConfig: {}
});

const getListAjax = async params => {
  return await continuousLabourList({ ...params, taxType: 3 });
};
</script>
<style lang="scss"></style>
